export default "__VITE_ASSET__mZN2bC_J__"